import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Loading } from "pages/parts/Loading";
import { Header } from "pages/parts/Header";
import { Navbar } from "pages/parts/Navbar";
import { Footer } from "pages/parts/Footer";
import { Signin } from "pages/signin/Signin";
import { SigninContext } from "pages/signin/SigninContext";
import { MyConfigApi } from "api/MyConfigApi";
import { UserApi } from "api/UserApi";
import { User } from "api/entities/User";
import * as CommonConstants from "utilities/CommonConstants";
import "pages/Layout.css";

const useStyles = makeStyles(() => ({
    frame: {
        margin: "1%",
    },
    loading: {
        width: "20%",
        margin: "0 auto",
        marginTop: 150,
    },
}));

export const Layout: React.FC = ({ children }) => {
    const classes = useStyles();
    const [success, setSuccess] = useState<boolean>(false);
    const [config, setConfig] = useState<string | null>(sessionStorage.getItem(CommonConstants.SESSION_KEY_CONFIG));

    useEffect(() => {
        const execute = async () => {
            // config情報を取得し、sessionStrageに保持
            const result = await MyConfigApi.getConfig();
            if (result?.data !== undefined) {
                sessionStorage.setItem(CommonConstants.SESSION_KEY_CONFIG, JSON.stringify(result?.data));
            }
            setConfig(`1`);
            // ログインユーザ情報取得
            const user: User = await UserApi.getUser();
            setSuccess(user.signin);
        };
        execute();
    }, [config, success]);

    return (
        <div className={classes.frame}>
            <SigninContext.Provider value={{ success, setSuccess }}>
                <Header />
                <Navbar />
                {success ? (
                    <main id="solvent" className="solvent-mainContent">
                        {config === null ? <Loading isLoading={config == null} /> : children}
                    </main>
                ) : (
                    <Signin />
                )}
                <Footer />
            </SigninContext.Provider>
        </div>
    );
};
